import React from 'react';
import * as PropTypes from 'prop-types';
import { Button, Card } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faFileAlt,
  faCopy,
  faSave,
  faFolderOpen,
  faShareAlt,
} from '@whitebox-learning/fontawesome-pro-light-svg-icons';
import MenuTitle from './MenuTitle';
import {
  FM_MENU_NEW,
  FM_MENU_SAVE,
  FM_MENU_OPEN,
  FM_MENU_FORK,
  FM_MENU_SHARE,
} from '../../constants/filemanager';

import './Menu.sass';

const MainMenu = ({ workingConcept, selectMenu, close, isTeacher }) => (
  <div className="fm-simple-panel">
    <MenuTitle close={close}>File Manager</MenuTitle>
    <div className="fm-scroll fm-main-menu">
      <Card className="mb-2">
        <Card.Body>
          You are currently working on
          {workingConcept.length ? (
            <h3 className="text-center" style={{ margin: 0 }}>
              {workingConcept}
            </h3>
          ) : (
            ' an untitled design concept.'
          )}
        </Card.Body>
      </Card>

      <Card className="mb-1">
        <Card.Body className="d-flex justify-content-between align-items-center">
          <Button
            id="fm-new-design-menu-button"
            variant="outline-primary"
            onClick={() => selectMenu(FM_MENU_NEW)}
          >
            <FontAwesomeIcon icon={faFileAlt} size="2x" />
            <br /> New
          </Button>
          <p className="m-0 text-end">Start a new design concept</p>
        </Card.Body>
      </Card>

      <Card className="mb-1">
        <Card.Body className="d-flex justify-content-between align-items-center">
          <Button
            id="fm-fork-design-menu-button"
            variant="outline-primary"
            onClick={() => selectMenu(FM_MENU_FORK)}
          >
            <FontAwesomeIcon icon={faCopy} size="2x" />
            <br /> Fork
          </Button>
          <p className="m-0 text-end">
            Fork an existing design concept
            <br />
            <span className="text-muted fs-7">
              (Start new design based on existing design)
            </span>
          </p>
        </Card.Body>
      </Card>

      <Card className="mb-1">
        <Card.Body className="d-flex justify-content-between align-items-center">
          <Button
            id="fm-save-design-menu-button"
            variant="outline-primary"
            onClick={() => selectMenu(FM_MENU_SAVE)}
          >
            <FontAwesomeIcon icon={faSave} size="2x" />
            <br /> Save
          </Button>
          <p className="m-0 text-end">
            Save a working copy
            <br /> or enter the competition
          </p>
        </Card.Body>
      </Card>

      <Card className="mb-1">
        <Card.Body className="d-flex justify-content-between align-items-center">
          <Button
            id="fm-open-design-menu-button"
            variant="outline-primary"
            onClick={() => selectMenu(FM_MENU_OPEN)}
          >
            <FontAwesomeIcon icon={faFolderOpen} size="2x" />
            <br /> Open
          </Button>
          <p className="m-0 text-end">Open an existing concept</p>
        </Card.Body>
      </Card>

      {isTeacher && (
        <Card className="mb-1">
          <Card.Body className="d-flex justify-content-between align-items-center">
            <Button
              id="fm-share-design-menu-button"
              variant="outline-primary"
              onClick={() => selectMenu(FM_MENU_SHARE)}
            >
              <FontAwesomeIcon icon={faShareAlt} size="2x" />
              <br /> Share
            </Button>
            <p className="m-0 text-end">
              Share design concepts with your group
              <br />
              <span className="text-muted fs-7">
                (Only available to teachers)
              </span>
            </p>
          </Card.Body>
        </Card>
      )}
    </div>
  </div>
);

MainMenu.propTypes = {
  workingConcept: PropTypes.string,
  selectMenu: PropTypes.func.isRequired,
  close: PropTypes.func.isRequired,
};
MainMenu.defaultProps = {
  workingConcept: '',
};

export default MainMenu;
